module.exports = __webpack_public_path__ + "img/IMG_1297.0dcc61c1.png";